import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { hover, bp } from '../../styles/helpers';

const CarouselWrap = styled.div`
  position: relative;
  overflow: hidden;
  outline: none;
  opacity: ${props => props.opacity};

  .flickity-viewport {
    position: relative;
  }

  .flickity-slider {
    width: 100%;
    height: 100%;
  }

  .flickity-button {
    position: absolute;
    top: 50%;
    width: 50px;
    height: 50px;
    background-color: ${props => props.theme.white};
    border: 0;
    transform: translateY(-50%);

    &.previous {
      left: 10.5%;

      ${screen.above('1800px', `
        left: calc((27% / 2) - 45px);
      `)}

      ${screen.below(bp.laptopSm, `
        left: 6.6%;
      `)}

      ${screen.below(bp.tablet, `
        left: 5.8%;
      `)}

      ${screen.below(bp.portrait, `
        left: calc(10% - 35px);
      `)}

      ${screen.below(bp.mobile, `
        left: 40px;
      `)}
    }

    &.next {
      right: 10.5%;

      ${screen.above('1800px', `
        right: calc((27% / 2) - 45px);
      `)}

      ${screen.below(bp.laptopSm, `
        right: 6.6%;
      `)}

      ${screen.below(bp.tablet, `
        right: 5.8%;
      `)}

      ${screen.below(bp.portrait, `
        right: calc(10% - 35px);
      `)}

      ${screen.below(bp.mobile, `
        right: 40px;
      `)}
    }

    ${props => hover(`
      svg {
        fill: ${props.theme.blue};
      }
    `)}

    ${screen.below(bp.laptop, `
      width: 40px;
      height: 40px;
    `)}
  }

  .flickity-button-icon {
    fill: ${props => props.theme.black};
    transition: fill 300ms ease-in-out;
    margin-top: 3px;
  }

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

export default CarouselWrap;
